var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReadAloudArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0628 6.47701L7.87685 12.4536C7.82997 12.5076 7.77202 12.551 7.70692 12.5808C7.64181 12.6105 7.57108 12.6258 7.49951 12.6258C7.42794 12.6258 7.35721 12.6105 7.2921 12.5808C7.227 12.551 7.16904 12.5076 7.12216 12.4536L1.93779 6.47701C1.92212 6.45899 1.91197 6.43685 1.90853 6.41323C1.90509 6.3896 1.90851 6.36549 1.91839 6.34375C1.92827 6.32202 1.94419 6.30359 1.96425 6.29064C1.98431 6.2777 2.00767 6.2708 2.03154 6.27075H3.29716C3.36904 6.27075 3.43779 6.302 3.48623 6.35669L6.90654 10.2989V1.50043C6.90654 1.43174 6.96279 1.37549 7.03154 1.37549H7.96904C8.03779 1.37549 8.09404 1.43174 8.09404 1.50043V10.2989L11.5144 6.35669C11.5612 6.302 11.63 6.27075 11.7034 6.27075H12.969C13.0753 6.27075 13.1331 6.39576 13.0628 6.47701Z",
    fill: "url(#paint0_linear_2139_10814)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2139_10814",
    x1: 7.53099,
    y1: 1.31429,
    x2: 7.53099,
    y2: 12.6259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2054E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C62FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadAloudArrow);
export default __webpack_public_path__ + "static/media/read-aloud-arrow.f85495a3304920f06543671a5734274c.svg";
export { ForwardRef as ReactComponent };